import { useState } from "react"; // ✅ ADDED: to control menu state
import { menuItems } from '../menuItems';
import MenuItems from './MenuItems';
import { GiHamburgerMenu } from 'react-icons/gi';
import { AiOutlineClose } from 'react-icons/ai';
import { slide as Menu } from 'react-burger-menu';


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); 
  // ✅ ADDED: state to control hamburger open/close

  const closeMenu = () => {
    setIsOpen(false); 
  };
  // ✅ ADDED: function to manually close menu

  return (
    <>
    <nav>
      <ul className="menus">
        {menuItems.map((menu, index) => {
          const depthLevel = 0;
          return (
            <MenuItems
              items={menu}
              key={index}
              depthLevel={depthLevel}
            />
          );
        })}
      </ul>
    </nav>
    <nav id = "HamburgerBar">
       <Menu
          isOpen={isOpen} 
          // ✅ ADDED: menu now controlled by state

          onStateChange={(state) => setIsOpen(state.isOpen)} 
          // ✅ ADDED: sync menu open/close with state
						noOverlay right width={ 240 }
							customBurgerIcon={<GiHamburgerMenu className="burgerMenuIcons" />}
							customCrossIcon={<AiOutlineClose  id="close" className="burgerMenuIcons" />} 
							>
                <ul className="menus">
                {menuItems.map((menu, index) => {
                  const depthLevel = 0;
                  return (
                    <MenuItems
                      items={menu}
                      key={index}
                      depthLevel={depthLevel}
                      closeMenu={closeMenu} 
                  // ✅ ADDED: pass close function to menu items
                    />
                  );
                })}
              </ul>
						</Menu>
			</nav>
    </>
  );
};

export default Navbar;
